import React from 'react';
import { node } from 'prop-types';
import { categoryShape } from 'shapes';
import { Provider } from '../CategoryContext';

const CategoryProvider = ({ category, children }) => {
    return (
        <Provider
            value={{
                state: {
                    category,
                },
            }}
        >
            {children}
        </Provider>
    );
};

CategoryProvider.propTypes = {
    category: categoryShape,
    children: node.isRequired,
};
CategoryProvider.defaultProps = {
    category: undefined,
};
export default CategoryProvider;
